import http from "utils/request";

// 添加商品到选品池
export const AddProductPool = (params = {}) => {
  return http.post("/api/member/add_product_pool", params);
};

// 修改选品池商品
export const SaveProductPool = (params = {}) => {
  return http.post("/api/member/save_product_pool", params);
};

// 获取选品详情
export const GetProductPoolInfo = (params = {}) => {
  return http.get("/api/member/get_product_pool_info", { params });
};

// 获取选品池列表
export const GetProductPool = (params = {}) => {
  return http.get("/api/member/get_product_pool", { params });
};

// 获取供应商列表
export const GetPoolStoreList = (params = {}) => {
  return http.get("/api/member/get_pool_store_list", { params });
};

// 删除选品池
export const DeleteProductPool = (params = {}) => {
  return http.post("/api/member/delete_product_pool", params);
};

// 设置选品池会员价
export const SetPoolMemberPrice = (params = {}) => {
  return http.post("/api/member/set_pool_member_price", params);
};

// 查看操作日志
export const GetPoolLog = (params = {}) => {
  return http.get("/api/member/get_pool_log", { params });
};

// 获取选品池中的会员价
export const GetPoolMemberPrice = (params = {}) => {
  return http.get("/api/member/get_pool_member_price", { params });
};

// 三方店铺到期数
export const GetStoreCount = (params = {}) => {
  return http.get("/api/member/get_store_count", { params });
};

// 上传记录 ---- start -----
// 获取上传记录
export const GetGoodsUploadLog = (params = {}) => {
  return http.get("/api/member/get_goods_upload_log", { params });
};

// 上传记录-批量操作  操作类型1是下架2是sku库存修改3是同步
export const SetGoodsUploadStatus = (params = {}) => {
  return http.post("/api/member/set_goods_upload_status", params);
};

// 上传记录-批量操作-获取用户异步处理结果
export const GetSyncHandleResult = (params = {}) => {
  return http.get("/api/member/get_sync_handle_result", { params });
};

// 上传记录-批量标记处理
export const MarkGoodsUploadLog = (params = {}) => {
  return http.post("/api/member/mark_goods_upload_log", params);
};

// 上传记录-获取供应商变更日志
export const GetSupplierLog = (params = {}) => {
  return http.get("/api/member/get_supplier_log", { params });
};

// 上传记录-获取部分下架详情
export const GetPartGoodsInfo = (params = {}) => {
  return http.get("/api/member/get_part_goods_info", { params });
};

// 上传记录-部分下架
export const SetPartGoodsStatus = (params = {}) => {
  return http.post("/api/member/set_part_goods_status", params);
};

// 上传记录 ---- end -----

// 商品标签 ---- start ----
export const GetPoolLabel = (params = {}) => {
  return http.get("/api/member/get_pool_label", { params });
};
export const AddPoolLabel = (params = {}) => {
  return http.post("/api/member/add_pool_label", params);
};
export const DeletePoolLabel = (params = {}) => {
  return http.post("/api/member/delete_pool_label", params);
};

export const SetProductPoolLabel = (params = {}) => {
  return http.post("/api/member/set_product_pool_label", params);
};
export const DelProductPoolLabel = (params = {}) => {
  return http.post("/api/member/del_product_pool_label", params);
};
// 商品标签 ---- end ----

// 快捷查询 ---- start ----
export const GetQuickSearch = (params = {}) => {
  return http.get("/api/member/get_quick_search", { params });
};
export const AddQuickSearch = (params = {}) => {
  return http.post("/api/member/add_quick_search", params);
};
export const DeleteQuickSearch = (params = {}) => {
  return http.post("/api/member/del_quick_search", params);
};
// 快捷查询 ---- end ----

// 利润模版 ---- start ----
export const GetPoolMobanList = (params = {}) => {
  return http.get("/api/member/get_pool_moban_list", { params });
};
export const SavePoolMoban = (params = {}) => {
  return http.post("/api/member/save_pool_moban", params);
};
export const DeletePoolMoban = (params = {}) => {
  return http.post("/api/member/delete_pool_moban", params);
};
export const SetDefaultMoban = (params = {}) => {
  return http.post("/api/member/set_default_moban", params);
};
// 利润模版 ---- end ----
